import { render } from "./CompositionAnalysisTab.vue?vue&type=template&id=432c54df"
import script from "./CompositionAnalysisTab.vue?vue&type=script&lang=js"
export * from "./CompositionAnalysisTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__